module.exports = __webpack_public_path__ + "static/media/HL11.f17ddb05.jpg";